import { render, staticRenderFns } from "./AddBook.vue?vue&type=template&id=4a8dbf3f&scoped=true"
import script from "./AddBook.vue?vue&type=script&lang=js"
export * from "./AddBook.vue?vue&type=script&lang=js"
import style0 from "./AddBook.vue?vue&type=style&index=0&id=4a8dbf3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8dbf3f",
  null
  
)

export default component.exports